// ANGULAR DEPENDANCY
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// EXTERNAL DEPENDANCY
import { Observable } from 'rxjs';

// SERVICES
import { ApiConfigService } from '../../../core/services/api-config/api-config.service';
import { BaseService } from '../../../core/services/base/base.service';
import { TokenStorageService } from '../../../core/services/token-storage/token-storage.service';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';
import { ApiResponse } from '../../../../models/common/api/api-response.interface';

// COMMON UTILS
import { APIUtil } from '../../../../core/utils/api-util';

// CONSTANTS
import { USER_API_URL } from '../../../../constants/api/user';

/**
 * This service is for User api calls
 * For handle User api calls
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 28/05/2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>) initially created User service
 */
@Injectable()
export class UserService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    protected tokenStorage: TokenStorageService,
    public apiConfig: ApiConfigService,
  ) {
    super(httpClient, tokenStorage);
  }

  /**
	 * User common master api
	 * @param payload : Api common payload object
	 * @returns Observable<ApiResponse>
	 */
  public userCommon(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['type'];
    const url = APIUtil.getReplaceParams(
      `${this.apiConfig.getApiUrl()}${USER_API_URL[payload.data.type]}`,
      replaceParams,
      payload,
    );

    return this.post(url, payload.data.data);
  }
  /**
   * Update the contact
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public updateContact(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${
      USER_API_URL.UPDATE_USER_CONTACT_BULK
      }`;

    return this.put(url, payload);
  }
  /**
   * Update the address
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public updateAddress(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${
      USER_API_URL.UPDATE_USER_BUSINESS_ADDRESS_BULK
      }`;

    return this.put(url, payload);
  }
  /**
	 * Get User Contacts
	 * @param payload : Api common payload object
	 * @returns Observable<ApiResponse>
	 */
  public getUserContact(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['userId'];
    const url = APIUtil.getAppendParams(
      `${this.apiConfig.getApiUrl()}${USER_API_URL.GET_USER_CONTACT_BY_USER}`,
      replaceParams,
      payload,
    );

    return this.get(url);
  }
  /**
   * Get Client-Area Data with give page no and size
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getUserAddress(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['userId'];
    const url = APIUtil.getAppendParams(
      `${this.apiConfig.getApiUrl()}${USER_API_URL.GET_USER_BUSINESS_ADDRESS_BY_USER}`,
      replaceParams,
      payload,
    );

    return this.get(url);
  }
}
